<template>
    <div :style="'background: rgba(0, 0, 0, 0.5);width:' + width / 1920*100 + 'vw;height:' + height / 870*100 + 'vh'">
        <div class="detailBody">
            <div class="title">
                <div>{{currentLoop[0].loopName}}</div>
                <img src="@/assets/img/黑色关闭.png" alt="" @click="$emit('closeLoopDetail')">
            </div>
            <div class="tab" id="diagramTab">
                <el-tabs v-model="activeName">
                    <el-tab-pane label="电力数据" name="电力数据">电力数据</el-tab-pane>
                    <!-- <el-tab-pane v-if="areaId == 22" label="控制" name="控制">控制</el-tab-pane>
                    <el-tab-pane v-if="areaId == 22" label="分合历史" name="分合历史">分合历史</el-tab-pane> -->
                </el-tabs>
            </div>
            <div class="table" id="diagramTable" v-show="activeName == '电力数据'">
                <el-table v-if="tableData.length > 0" :data="tableData" border style="width: 100%"
                    :header-cell-style="{padding: '0'}" :header-row-style="{ height: 400/108 + 'vh' }"
                    :row-style="{ height: 400/108 + 'vh' }" :cell-style="{ padding: '0' }" height="100%">
                    <el-table-column fixed align="center" prop="node" label="参数名称">
                    </el-table-column>
                    <el-table-column fixed align="center" prop="realValue" label="实时数据">
                    </el-table-column>
                    <el-table-column fixed align="center" prop="max" label="当日最大值">
                    </el-table-column>
                    <el-table-column fixed align="center" prop="max_time" label="最大值时间">
                    </el-table-column>
                    <el-table-column fixed align="center" prop="min" label="当日最小值">
                    </el-table-column>
                    <el-table-column fixed align="center" prop="min_time" label="最小值时间">
                    </el-table-column>
                </el-table>

                <div v-else class="row-center tip">
                    <img src="@/assets/img/loading.png" alt="" class="loading">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        EXTREMUM_VALUES,
    } from '@/components/Request'
    import {
        dateFormat,
    } from "@/components/DateUtil"
    import {
        floatFormat
    } from "@/components/MathUtil"

    export default {
        name: "LoopDetail",
        props: ['width', 'height', 'loopUrl', 'tab', 'currentLoop'],
        data() {
            return {
                areaId: 21,
                loopsIdArr: [],
                activeName: this.tab || '电力数据',

                extremNodes: ['Ua', 'Ub', 'Uc', 'Ia', 'Ib', 'Ic', "PA", "PR", "P", "PF", "U_unbl", "I_unbl"],
                requestRes: [],
                nodes: ["Ua", "Ub", "Uc", "Ia", "Ib", "Ic", "PA", "PR", "P", "PF", "U_unbl", "I_unbl"],
            }
        },
        computed: {
            tableData() {
                if (this.requestRes.length === 0) {
                    return []
                }
                let data = []
                this.currentLoop.map(l => {
                    this.extremNodes.map(n => {
                        let obj = {}
                        this.requestRes.forEach((res, index) => {
                            obj['loopName'] = l.loopName
                            obj['node'] = this.getChinese(n) + this.getUnit(n)
                            let extremum = res.data.data.extremum;
                            for (let k in extremum) {
                                if (extremum.hasOwnProperty(k)) {
                                    var start = k.indexOf("/");
                                    var s = k.substring(start + 1);
                                    extremum[s] = extremum[k]
                                }
                            }
                            // console.log(extremum)
                            if (typeof (extremum) == 'undefined')
                                return []
                            // console.log(extremum[`${l.subLoopUrl}_${n}`])
                            if (extremum[`${l.subLoopUrl}_${n}`]) {
                                if (index === 0) {
                                    obj['max'] = floatFormat(extremum[`${l.subLoopUrl}_${n}`].max, 2)
                                    obj['max_time'] = this.timeGenerate(extremum[`${l.subLoopUrl}_${n}`].time)
                                }
                                if (index === 1) {
                                    obj['min'] = floatFormat(extremum[`${l.subLoopUrl}_${n}`].min, 2)
                                    obj['min_time'] = this.timeGenerate(extremum[`${l.subLoopUrl}_${n}`].time)
                                }
                            } else {
                                if (index === 0) {
                                    obj['max'] = '--'
                                    obj['max_time'] = '--'
                                }
                                if (index === 1) {
                                    obj['min'] = '--'
                                    obj['min_time'] = '--'
                                }
                            }
                            obj['realValue'] = this.$store.state.MQTTObj[`${l.subLoopUrl}/${n}`] == undefined ? '--' :
                                parseFloat(Number(this.$store.state.MQTTObj[`${l.subLoopUrl}/${n}`]).toFixed(2))
                        })
                        data.push(obj)
                    })
                })
                return this.$store.state.projectId == 4 ? data.filter(item => item.node.indexOf('不平衡度') == -1) : data
            },
        },
        created() {
            this.loopsIdArr = [this.currentLoop[0].loopId]
            this.requestValues()
        },
        methods: {
            timeGenerate(time) {
                let date = new Date(time);
                return dateFormat("HH:MM:SS", date)
            },
            async requestValues() {
                this.requestRes = [];
                if (this.loopsIdArr.length === 0 || this.extremNodes.length === 0) {
                    return
                }
                let res = []
                try {
                    res = await Promise.all([
                        EXTREMUM_VALUES(this.loopsIdArr, this.extremNodes, "MAX", new Date()),
                        EXTREMUM_VALUES(this.loopsIdArr, this.extremNodes, "MIN", new Date()),
                    ])
                } catch (e) {

                } finally {
                    this.requestRes = res
                    return res
                }
            },
            getUnit(n) {
                if (n == 'Ua' || n == 'Ub' || n == 'Uc') {
                    return '(V)'
                } else if (n == 'Ia' || n == 'Ib' || n == 'Ic') {
                    return '(A)'
                } else if (n == 'U_unbl' || n == 'I_unbl') {
                    return '(%)'
                } else if (n == 'PA') {
                    return '(W)'
                } else if (n == 'PR') {
                    return '(var)'
                } else if (n == 'P') {
                    return '(VA)'
                } else {
                    return ''
                }
            },
            getChinese(n) {
                switch (n) {
                    case 'Ua':
                        return 'A相电压'
                    case 'Ub':
                        return 'B相电压'
                    case 'Uc':
                        return 'C相电压'
                    case 'Ia':
                        return 'A相电流'
                    case 'Ib':
                        return 'B相电流'
                    case 'Ic':
                        return 'C相电流'
                    case 'PA':
                        return '有功功率'
                    case 'PR':
                        return '无功功率'
                    case 'P':
                        return '视在功率'
                    case 'PF':
                        return '功率因数'
                    case 'U_unbl':
                        return '电压不平衡度'
                    case 'I_unbl':
                        return '电流不平衡度'
                    default:
                        return ''
                }
            },
        }
    };
</script>

<style lang="less" scoped>
    .detailBody {
        .w(880);
        // .h(640);
        min-height: 450rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #fff;
        opacity: 1;
        overflow-y: hidden;

        transition: all 0.5s;

        .title {
            width: 100%;
            .h(65);
            padding: 0 240/192vw;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid rgba(0, 0, 0, 0.06);
            font-size: 18rem;
            font-weight: bold;
            color: #333333;

            img {
                cursor: pointer;
            }
        }

        .tab {
            border-bottom: 1px solid rgba(0, 0, 0, 0.06);
            padding: 0 240/192vw;
        }

        .table {
            width: 100%;
            // height: 55vh;
            min-height: 450rem;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            overflow: hidden;
            //火狐隐藏滚动条
            scrollbar-width: none;

            ::-webkit-scrollbar {
                display: none;
            }
        }
    }

    .pagination {
        height: 6vh;
        .w(300);
        align-self: flex-end;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-evenly;
        font-size: 14rem;

        .button {
            .w(74);
            .h(24);
            border: 1px solid rgba(0, 0, 0, 0.15);
            border-radius: 2px;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    .tip {
        width: 100%;
        height: 100%;
        font-size: 16rem;
        color: #8c939d;
    }

    .loading {
        width: 28rem;
        height: 28rem;
        animation: loading 1s linear infinite;
    }

    @keyframes loading {
        0% {
            transform: rotate(0);
        }

        100% {
            transform: rotate(360deg);
        }
    }

    .control {
        .w(500);
        .h(300);
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 22rem;

        .circleload {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-evenly;
            align-items: center;
        }


        .state {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-evenly;
            align-items: center;

            .control_btn {
                width: 96rem;
                height: 40rem;
                background: #0D94FF;
                font-size: 18rem;
                display: flex;
                justify-content: center;
                align-items: center;
                color: white;
                cursor: pointer;
            }
        }
    }

    .popup {
        width: 528rem;
        height: 248rem;
        background: #FFFFFF;
        box-shadow: 0px 4px 40px 0px rgba(0, 43, 102, 0.28);
        border-radius: 2px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;

        .firstLine {
            width: 85%;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: flex-start;
            margin-left: 32rem;

            .icon {
                width: 22rem;
                height: 22rem;
                margin-right: 17rem;
                margin-top: 5.5rem;
            }
        }

        .secondLine {
            height: 50rem;
            font-size: 16rem;
            color: #999;
            margin-left: 70rem;

            input {
                border-bottom: 1rem solid #ccc;
                width: 56rem;
                margin: 0 8rem;
            }

            .randomNum {
                width: 56rem;
                background: #EEEEEE;
                border-radius: 4rem;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #666;
            }
        }

        .thirdLine {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;
            font-size: 14rem;

            .cancle {
                width: 60rem;
                height: 32rem;
                border: 1px solid rgba(0, 0, 0, 0.15);
                border-radius: 2rem;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                color: #333;
                cursor: pointer;
            }

            .confirm {
                width: 60rem;
                height: 32rem;
                background: #0D94FF;
                border-radius: 2rem;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                color: #fff;
                margin-left: 8rem;
                margin-right: 32rem;
                cursor: pointer;
            }
        }
    }

    .history {
        width: 100%;
        .h(520);
    }
</style>